import {
  Box,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import StudentRegForm from "./Students_reg_Form";
import Student_reg_Table from "./Student_reg_Table";

const Registration = () => {
  return (
    <Box maxWidth="100%">
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", margin: 0 }}>Teacher Event Details</h1>
          <div className="action-buttons" style={{ marginLeft: "auto" }}>
            <div className="export-dropdown">
              <StudentRegForm />
            </div>
          </div>
        </div>

        <Box className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Event </span> /{" "}
          <Link
            to="/class/classlist"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Event Details</span>
          </Link>
        </Box>
      </div>


        {/* Displaying the student registration table */}
        <Student_reg_Table />

      
    </Box>
  );
};

export default Registration;
